import React, { useState } from 'react'
import { Box } from '../../../shared_components/UI/Box'
import { FAQContainer } from './styles'

const faqItems = [
  {
    title: 'When will I receive my tokens?',
    content: `You will receive your tokens as per the project's vesting schedule, with the first vesting point always occurring on TGE. Please ensure you are familiar with the project's vesting schedule.`,
  },
  {
    title: 'Where can I claim my tokens?',
    content:
      'All your investments and associated tokens can be found and claimed in your ZAP Dashboard.',
  },
  {
    title: 'What is dilution and how does it work?',
    content: `Dilution occurs when a raise is oversubscribed, eg. surpasses its raise target. This means there is more capital allocated than their is tokens available. Dilution ensures that every investor receives a fair amount of tokens, regardless of when they participate. 
      
      For example, if a token sale reaches 200% of its raise target, each investor's position is diluted by 50%. This ensures that they receive 50% of their initial investment in form of the project token, and another 50% as an instant USDB/ETH refund at sale end.`,
  },
  {
    title: 'How can I claim my refund?',
    content:
      'All refunds can be found on the ZAP Dashboard along with tokens to be vested. To claim your refund, simply click refund button and accept the transaction in your wallet.',
  },
  {
    title: 'What is KYC?',
    content: `KYC (Know Your Customer) is the process of identifying and verifying the client's identity, in this case, the investor. A project may require you to complete KYC to ensure you meet certain regulation requirements. 
      KYC is a common practice used in many industries such as the financial industry. If you wish to open a new bank, or credit card, you are required to provide your relevant identification.
      Organizations use KYC to know who their customer is and ensure they are within their guidelines of being allowed to work with. Sometimes, countries ban or prevent certain people from activities.`,
  },
]

const FAQ = ({ isBlock = false }) => {
  const [activeIndex, setActiveIndex] = useState(-1)
  return (
    <FAQContainer isBlock={isBlock} hasActiveTerm={activeIndex >= 0}>
      <Box>
        <img src="/img/icons/info-blue.svg" alt="blue info icon" />
        <h6>FAQ &amp; Help</h6>
      </Box>
      <div className="psuedo-list">
        {faqItems.map(({ title, content }, index) => (
          <Box direction="column" key={index}>
            <Box
              className="list-item"
              align="center"
              onClick={() => setActiveIndex((p) => (p === index ? -1 : index))}
            >
              <img
                src="/img/icons/list-chevron-right.svg"
                alt="blue info icon"
                className={activeIndex === index ? 'chevron rotate' : 'chevron'}
              />
              <span>{title}</span>
            </Box>
            {activeIndex === index && <span className="copy">{content}</span>}
          </Box>
        ))}
      </div>
    </FAQContainer>
  )
}

export default FAQ
